const prod_na_fallback_url = 'https://d3a3saarspcyfn.cloudfront.net';
// TODO: update with prod url when ready
const sales_assistant_fallback_url =
  'https://atc.federated.ui.ssa.advertising.amazon.dev';

window.__AAC_CHROME_REMOTE_URLS__ = window.__AAC_CHROME_REMOTE_URLS__ || {
  bellDrawer: prod_na_fallback_url,
  salesAssistant: sales_assistant_fallback_url,
};

window.__AAC_CHROME_REMOTE_URLS__.bellDrawer =
  window.__AAC_CHROME_REMOTE_URLS__.bellDrawer || prod_na_fallback_url;

window.__AAC_CHROME_REMOTE_URLS__.salesAssistant =
  window.__AAC_CHROME_REMOTE_URLS__.salesAssistant ||
  sales_assistant_fallback_url;
